import Plugins from './util/plugins';
import Accordion from './components/accordion';
// import Navigation from './components/navigation';
import search from './components/search';
import Footer from './components/footer';
import Minicart from './components/miniCart';
import Header from './components/header';
import AnalyticsHelper from './analyticsHelper';
import Geoblock from './components/geoblock';
import Menu from './components/menu';
import PrivacyPopUpFlag from './components/privacyPolicyPopUp';
import FormHelpers from './util/form';
import applyOmnibusWhiteText from './util/omnibusWhiteText';
import { processInclude, enqueueTask } from './util/common';
import RegistrationHelper from './account/registrationHelper';
import ProfileEnrich from './profileEnrich';
import ChosenAudioeye from './chosenAudioeye';

// Global variable
window.raf = window.requestAnimationFrame
    || window.webkitRequestAnimationFrame
    || window.mozRequestAnimationFrame
    || window.msRequestAnimationFrame
    || function (cb) { return setTimeout(cb, 16); };

document.addEventListener('DOMContentLoaded', () => {
    // Navigation.init();
    ProfileEnrich.initOutsideClickHandler();
    Plugins.init();
    Accordion.setup();
    Footer.init();
    FormHelpers.init($('form'));
    try {
        Geoblock.init();
    } catch (e) {
    }
    Header.init();
    Minicart.run();
    applyOmnibusWhiteText();
    AnalyticsHelper.init();
    // ExternalScript.init();
    enqueueTask(function () {
        // processInclude(require('./components/carouselComponents'));
        processInclude(require('./components/tabsComponents'));
    });
    // processInclude(require('./components/prefooterCarousel'));
    processInclude(require('./components/privacyPolicy'));
    search();
    if ($('.js-analytics-data-async').length > 0) {
        $.ajax($('.js-analytics-data-async').data('url')).then(function (rsp) {
            $('body').prepend(rsp);
        });
    }
    Menu.init();
    if (window.location.href.toLowerCase().includes('caseorigin=app')) {
        window.sessionStorage.setItem('caseorigin', 'app');
    }
    ChosenAudioeye.init();
    PrivacyPopUpFlag.init();
    processInclude(require('./personalization/personalization'));
    RegistrationHelper.modalRegistrationInit();
});
